import firebase from "../../Config/firebase";
import React, {Component} from "react";
import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCardImage,
    MDBCol,
    MDBContainer,
    MDBRow
} from "mdbreact";
import classes from "./ViewArticle.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faShare, faThumbsDown, faThumbsUp, faUserCircle} from "@fortawesome/free-solid-svg-icons";
import parse from "html-react-parser/index";
import ListReviewBox from "../ListReviewsBox/ListReviewBox";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import ProgImg from "react-prog-img";

import ReactQuillDisplayCss from '../../Utils/ReactQuillDisplay.module.css'

const db = firebase.firestore()

class ViewArticle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            article: {},
            isLoaded: false,
        }
    }

    componentDidMount() {
        if (typeof this.props.location.state !== "undefined") {
            if (this.props.location.state.hasOwnProperty('article')) {
                this.setState({
                    article: this.props.location.state.article
                }, () => {
                    this.setState({
                        isLoaded: true
                    })
                })

            }
        } else {
            this.getArticleByID(this.props.match.params.id)
        }
    }

    timeStampToString = (ts) => {
        const date = new Date(ts * 1000)
        return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()
    }

    getArticleByID = (aid) => {
        db.collection('Article')
            .doc(aid)
            .get()
            .then(doc => {
                if (doc.exists) {
                    this.setState({
                        article: doc.data()
                    }, () => {
                        this.setState({
                            isLoaded: true
                        })
                    })
                } else {
                    this.props.history.push({pathname: '/'})
                }
            })
    }

    render() {
        if (this.state.isLoaded) {
            return (
                <MDBContainer>
                    <MDBRow>
                        <MDBCol xl="12" lg="12" md='12' sm='12'>
                            <MDBCard className={classes.PostCard}>
                               <div className={classes.ArticleImageContainer}>
                                   <ProgImg
                                       src={ typeof this.state.article.featureImage !== 'undefined' && this.state.article.featureImage !== ''?
                                           this.state.article.featureImage
                                           :'https://mdbootstrap.com/img/Mockups/Lightbox/Thumbnail/img%20(67).jpg'
                                           }
                                       conf={{isLazy: false}}
                                       className={[classes.ArticleImage, "darkmode-ignore"].join(" ")}
                                       alt={""}
                                   />
                               </div>
                                <div className={classes.FloatingBtnContainer}>
                                    <MDBBtn className={classes.FloatingBtn}>
                                        <FontAwesomeIcon  icon={faShare}/>
                                    </MDBBtn>
                                </div>

                                <MDBCardBody className={classes.CardBody}>

                                    <div className={classes.ArticleContent}>
                                        <h1 className={classes.Title}>
                                            {this.state.article.title}
                                        </h1>
                                        <div className={classes.CardHeading}>
                                            <div className={classes.ArticleMetadata}>
                                                By Tmingler
                                                <span>
                                                    {this.timeStampToString(this.state.article.lastModified.seconds)}
                                                </span>
                                            </div>
                                        </div>
                                        <div className={classes.PostMain}>

                                            <main className={ReactQuillDisplayCss.ReactQuillDisplay}>
                                                {parse(this.state.article.content)}
                                            </main>
                                        </div>

                                    </div>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    </MDBRow>


                </MDBContainer>
            )
        } else {
            return (
                <div>
                    loading
                </div>
            )
        }
    }
}


const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default enhance(withRouter(ViewArticle))